// extracted by mini-css-extract-plugin
export default {"anchor":"card_anchor__pjm7o","card":"card_card__Fnkvl","badge":"card_badge__W1BiE"};